import { SIGNED_CHIP_VARIANT } from '@dealstack/frontend/shared/components/Chips/CommonChips';
import { SignatureType } from '@dealstack/shared/lib/common/business/contracts';
import {
	DocumentWorkflowInstanceSignatureStatus,
	DocumentWorkflowInstanceStatus,
	SignableContract,
} from '@dealstack/shared/lib/generated';

export const mapStatusToChipVariant = (
	status: DocumentWorkflowInstanceSignatureStatus,
	signatureType: SignatureType | null | undefined
): SIGNED_CHIP_VARIANT => {
	if (signatureType === SignatureType.REVIEW || !signatureType) {
		return SIGNED_CHIP_VARIANT.NOT_APPLICABLE;
	}

	switch (status) {
		case DocumentWorkflowInstanceSignatureStatus.SIGNED:
		case DocumentWorkflowInstanceSignatureStatus.COMPLETED:
			return SIGNED_CHIP_VARIANT.SIGNED;
		case DocumentWorkflowInstanceSignatureStatus.DECLINED:
			return SIGNED_CHIP_VARIANT.REJECTED;
		case DocumentWorkflowInstanceSignatureStatus.EXPIRED:
			return SIGNED_CHIP_VARIANT.EXPIRED;
		case DocumentWorkflowInstanceSignatureStatus.PENDING_SIGNATURE:
		case DocumentWorkflowInstanceSignatureStatus.CREATED:
			return SIGNED_CHIP_VARIANT.NOT_SIGNED;
		case DocumentWorkflowInstanceSignatureStatus.ERROR:
			return SIGNED_CHIP_VARIANT.REJECTED;
		case DocumentWorkflowInstanceSignatureStatus.WAITING_FOR_WITNESS_SIGNATURES:
			return SIGNED_CHIP_VARIANT.WAITING_FOR_WITNESS_SIGNATURES;
		default:
			return SIGNED_CHIP_VARIANT.NOT_SIGNED;
	}
};

export const mapInstanceStatusToChipVariant = (
	status: DocumentWorkflowInstanceStatus
): SIGNED_CHIP_VARIANT => {
	switch (status) {
		case DocumentWorkflowInstanceStatus.IN_PROGRESS:
		case DocumentWorkflowInstanceStatus.PENDING:
			return SIGNED_CHIP_VARIANT.IN_PROGRESS;
		case DocumentWorkflowInstanceStatus.CANCELLED:
			return SIGNED_CHIP_VARIANT.REJECTED;
		case DocumentWorkflowInstanceStatus.COMPLETED:
			return SIGNED_CHIP_VARIANT.COMPLETE;
		case DocumentWorkflowInstanceStatus.EXPIRED:
			return SIGNED_CHIP_VARIANT.EXPIRED;
		default:
			return SIGNED_CHIP_VARIANT.IN_PROGRESS;
	}
};

export type PreviewDocument = {
	fileId: string;
	fileName: string;
	fileBlob?: Blob;
	fileExtension?: string;
	documentWorkflowInstanceId?: string;
};

export type WetInkModalState = {
	contract: SignableContract | null;
	opened: boolean;
	selectedFile: File | undefined;
	isSaving: boolean;
};
